import React, { useState } from 'react';

function CollegeProfileForm() {
  const [formData, setFormData] = useState({
    name: '',
    address: '',
    city: '',
    pin: '',
    state: '',
    website: ''
  });

  const handleChange = (e) => {
    setFormData({ 
      ...formData, 
      [e.target.name]: e.target.value 
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('/api/college-profile', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });
      if (response.ok) {
        alert('Profile saved successfully');
        setFormData({
          name: '',
          address: '',
          city: '',
          pin: '',
          state: '',
          website: ''
        });
      } else {
        alert('Error saving profile');
      }
    } catch (error) {
      console.error('Submission error:', error);
      alert('Error saving profile');
    }
  };

    // Common style for inputs and textarea (removes their default border)
    const inputStyle = {
        width: '100%',
        boxSizing: 'border-box',
        border: 'none',      // remove the input's own border
        outline: 'none',
        fontSize: '14px'
      };

  return (

    <form onSubmit={handleSubmit}>
      <h2 style={{ textAlign: 'center' }}>2. Profile of the College</h2>
      <h3>1. Basic Information</h3>
      {/* Header section */}
      <div
        style={{
          
          fontWeight: 'bold'
        }}
      >
        Name and Address of the College:
      </div>
            {/* Table with collapsed borders so cells align nicely */}
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <tbody>
        
          {/* NAME row */}
          <tr>
            <td style={{ border: '1px solid black', width: '150px', padding: '8px' }}>
              Name :
            </td>
            <td style={{ border: '1px solid black', padding: '8px' }}>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                style={inputStyle}//style={{ width: '100%', boxSizing: 'border-box' }}
                required
              />
            </td>
          </tr>

          {/* ADDRESS row */}
          <tr>
            <td style={{ border: '1px solid black', width: '150px', padding: '8px' }}>
              Address :
            </td>
            <td style={{ border: '1px solid black', padding: '8px' }}>
              <input
                name="address"
                value={formData.address}
                onChange={handleChange}
                //rows="2"
                style={inputStyle}//style={{ width: '100%', boxSizing: 'border-box' }}
                required
              />
            </td>
          </tr>

          {/* CITY/PIN/STATE row */}
          <tr>
            <td style={{ border: '1px solid black', width: '150px' ,padding: '8px' }}>
              City :
            </td>
            <td style={{ }}>
              <td style={{  borderRight: '1px solid black', width: '20%',  padding: '8px' }}>
                <input
                  type="text"
                  name="city"
                  placeholder="City"
                  value={formData.city}
                  onChange={handleChange}
                  style={inputStyle}//style={{ marginRight: '10px' }}
                  required
                />
              </td>
              <td style={{  borderRight: '1px solid black', width: 'auto', padding: '8px' }}>
                Pin :{' '}
              </td>
              <td style={{  borderRight: '1px solid black',width: '20%', padding: '8px' }}>
                <input
                  type="text"
                  name="pin"
                  placeholder="Pin"
                  value={formData.pin}
                  onChange={handleChange}
                  style={inputStyle}//style={{ margin: '0 10px' }}
                  required
                />
              </td>
              <td style={{  borderRight: '1px solid black', width: 'auto',  padding: '8px' }}>
                State :{' '}
              </td>
              <td style={{  borderRight: '1px solid black', width: '20%', padding: '8px' }}>
                <input
                  type="text"
                  name="state"
                  placeholder="State"
                  value={formData.state}
                  onChange={handleChange}
                  style={inputStyle}//style={{ margin: '0 10px' }}
                  required
                />
              </td>
            </td>
          </tr>

          {/* WEBSITE row */}
          <tr>
            <td style={{ border: '1px solid black', width: '150px', padding: '8px' }}>
              Website :
            </td>
            <td style={{ border: '1px solid black', padding: '8px' }}>
              <input
                type="url"
                name="website"
                value={formData.website}
                onChange={handleChange}
                style={inputStyle}//style={{ width: '100%', boxSizing: 'border-box' }}
                required
              />
            </td>
          </tr>
        </tbody>
      </table>


      <button type="submit">Submit</button>
    </form>
  );
}

export default CollegeProfileForm;
